import { useRouter } from 'next/router';

export const useEnterpriseSiteRedirect = (enterpriseSiteURL?: string) => {
  const router = useRouter();

  if (enterpriseSiteURL) {
    const enterpriseSiteDomain = new URL(enterpriseSiteURL).hostname;
    if (
      typeof window !== 'undefined' &&
      enterpriseSiteDomain &&
      window.location.host !== enterpriseSiteDomain
    ) {
      window.location.replace(enterpriseSiteURL + router.asPath);
    }
  }
};
